export default [{
  children: [{
    id: 10101,
    value: '休闲时间'
  },
  {
    id: 10102,
    value: '跑酷竞速'
  },
  {
    id: 10103,
    value: '宝石消除'
  },
  {
    id: 10104,
    value: '网络游戏'
  },
  {
    id: 10105,
    value: '动作射击'
  },
  {
    id: 10106,
    value: '扑克棋牌'
  },
  {
    id: 10107,
    value: '儿童益智'
  },
  {
    id: 10108,
    value: '塔防守卫'
  },
  {
    id: 10109,
    value: '体育格斗'
  },
  {
    id: 10110,
    value: '角色扮演'
  },
  {
    id: 10111,
    value: '经营策略'
  }
  ],
  id: 10001,
  value: '游戏'
},
{
  children: [{
    id: 10201,
    value: '家装建材'
  },
  {
    id: 10202,
    value: '家居家纺'
  },
  {
    id: 10203,
    value: '家用电器'
  },
  {
    id: 10204,
    value: '家电维修'
  },
  {
    id: 10205,
    value: '日用百货'
  }
  ],
  id: 10002,
  value: '家装百货'
},
{
  children: [{
    id: 10301,
    value: '股票基金'
  },
  {
    id: 10302,
    value: '保险'
  },
  {
    id: 10303,
    value: '彩票'
  },
  {
    id: 10304,
    value: '期货外汇'
  },
  {
    id: 10305,
    value: '银行理财'
  },
  {
    id: 10306,
    value: '互联网金融'
  },
  {
    id: 10307,
    value: '贵金属'
  }
  ],
  id: 10003,
  value: '金融理财'
},
{
  children: [{
    id: 10401,
    value: '学前教育'
  },
  {
    id: 10402,
    value: '中小学教育'
  },
  {
    id: 10403,
    value: '大学教育'
  },
  {
    id: 10404,
    value: '职业教育'
  },
  {
    id: 10405,
    value: '学历教育'
  },
  {
    id: 10406,
    value: '语言培训'
  },
  {
    id: 10407,
    value: 'IT培训'
  },
  {
    id: 10408,
    value: '公务员考试'
  },
  {
    id: 10409,
    value: '出国留学'
  },
  {
    id: 10410,
    value: '技能培训'
  },
  {
    id: 10411,
    value: '拓展训练'
  }
  ],
  id: 10004,
  value: '教育培训'
},
{
  children: [{
    id: 10501,
    value: '本地周边游'
  },
  {
    id: 10502,
    value: '国内游'
  },
  {
    id: 10503,
    value: '港澳台游'
  },
  {
    id: 10504,
    value: '境外游'
  },
  {
    id: 10505,
    value: '户外探险'
  },
  {
    id: 10506,
    value: '主题旅游'
  },
  {
    id: 10507,
    value: '酒店住宿'
  },
  {
    id: 10508,
    value: '交通票务'
  }
  ],
  id: 10005,

  value: '旅游出行'
},
{
  children: [{
    id: 10601,
    value: '时尚女装'
  },
  {
    id: 10602,
    value: '精品男装'
  },
  {
    id: 10603,
    value: '女鞋'
  },
  {
    id: 10604,
    value: '男鞋'
  },
  {
    id: 10605,
    value: '内衣'
  },
  {
    id: 10606,
    value: '珠宝配饰'
  },
  {
    id: 10607,
    value: '童装童鞋'
  },
  {
    id: 10608,
    value: '箱包皮具'
  },
  {
    id: 10609,
    value: '手表'
  }
  ],
  id: 10006,

  value: '服饰箱包'
},
{
  children: [{
    id: 10701,
    value: '低档车'
  },
  {
    id: 10702,
    value: '中档车'
  },
  {
    id: 10703,
    value: '高档车'
  },
  {
    id: 10704,
    value: '二手车'
  },
  {
    id: 10705,
    value: '租车'
  },
  {
    id: 10706,
    value: '车辆养护'
  }
  ],
  id: 10007,

  value: '汽车'
},
{
  children: [{
    id: 10801,
    value: '减肥瘦身'
  },
  {
    id: 10802,
    value: '美容整形'
  },
  {
    id: 10803,
    value: '美发护发'
  },
  {
    id: 10804,
    value: '化妆护肤'
  }
  ],
  id: 10008,

  value: '美容化妆'
},
{
  children: [{
    id: 10901,
    value: '租房'
  },
  {
    id: 10902,
    value: '二手房'
  },
  {
    id: 10903,
    value: '普通住宅'
  },
  {
    id: 10904,
    value: '别墅豪宅'
  },
  {
    id: 10905,
    value: '写字楼'
  }
  ],
  id: 10009,

  value: '房产'
},
{
  children: [{
    id: 11001,
    value: '餐馆'
  },
  {
    id: 11002,
    value: '烹饪用品'
  },
  {
    id: 11003,
    value: '零食'
  },
  {
    id: 11004,
    value: '水果蔬菜'
  },
  {
    id: 11005,
    value: '其他生鲜'
  },
  {
    id: 11006,
    value: '面包蛋糕'
  },
  {
    id: 11007,
    value: '饮料'
  },
  {
    id: 11008,
    value: '酒水'
  },
  {
    id: 11009,
    value: '进口食品'
  }
  ],
  id: 10010,

  value: '餐饮美食'
},
{
  children: [{
    id: 11101,
    value: '孕妇用品'
  },
  {
    id: 11102,
    value: '胎教相关'
  },
  {
    id: 11103,
    value: '宝宝用品'
  },
  {
    id: 11104,
    value: '宝宝食品'
  },
  {
    id: 11105,
    value: '写真拍照'
  },
  {
    id: 11106,
    value: '儿童玩具'
  }
  ],
  id: 10011,

  value: '母婴儿童'
},
{
  children: [{
    id: 11201,
    value: '手机及配件'
  },
  {
    id: 11202,
    value: '电脑周边'
  },
  {
    id: 11203,
    value: '数码摄像'
  },
  {
    id: 11204,
    value: '网络设备'
  },
  {
    id: 11205,
    value: '游戏机'
  },
  {
    id: 11206,
    value: '办公设备'
  }
  ],
  id: 10012,

  value: '科技数码'
},
{
  children: [{
    id: 11301,
    value: '球类运动'
  },
  {
    id: 11302,
    value: '休闲运动'
  },
  {
    id: 11303,
    value: '跑步骑行'
  },
  {
    id: 11304,
    value: '水上运动'
  },
  {
    id: 11305,
    value: '极限运动'
  },
  {
    id: 11306,
    value: '户外运动'
  },
  {
    id: 11307,
    value: '运动装备'
  }
  ],
  id: 10013,

  value: '体育运动'
},
{
  children: [{
    id: 11401,
    value: '美容美发'
  },
  {
    id: 11402,
    value: '家政服务'
  },
  {
    id: 11403,
    value: '摄影照相'
  },
  {
    id: 11404,
    value: '宠物用品'
  },
  {
    id: 11405,
    value: '娱乐设施'
  },
  {
    id: 11406,
    value: '鲜花礼品'
  }
  ],
  id: 10014,

  value: '生活服务'
},
{
  children: [{
    id: 11501,
    value: '成人用品'
  },
  {
    id: 11502,
    value: '保健品'
  },
  {
    id: 11503,
    value: '医疗器械'
  },
  {
    id: 11504,
    value: '药品'
  },
  {
    id: 11505,
    value: '医疗诊疗'
  }
  ],
  id: 10015,

  value: '医疗健康'
},
{
  children: [{
    id: 11601,
    value: '司法鉴定'
  },
  {
    id: 11602,
    value: '律师服务'
  },
  {
    id: 11603,
    value: '公证'
  }
  ],
  id: 10016,

  value: '法律服务'
},
{
  children: [{
    id: 11701,
    value: '动漫周边'
  },
  {
    id: 11702,
    value: '桌游'
  },
  {
    id: 11703,
    value: '电影电视'
  },
  {
    id: 11704,
    value: '艺术展览'
  },
  {
    id: 11705,
    value: '演出'
  },
  {
    id: 11706,
    value: '酒吧KTV'
  },
  {
    id: 11707,
    value: '爱好收藏'
  },
  {
    id: 11708,
    value: '书籍杂志'
  }
  ],
  id: 10017,
  value: '文化娱乐'
},
{
  children: [{
    id: 11801,
    value: '办公文教'
  },
  {
    id: 11802,
    value: '求职招聘'
  },
  {
    id: 11803,
    value: '移民中介'
  },
  {
    id: 11804,
    value: '机械器材'
  },
  {
    id: 11805,
    value: '农林牧渔'
  },
  {
    id: 11806,
    value: '化工材料'
  },
  {
    id: 11807,
    value: '节能环保'
  },
  {
    id: 11808,
    value: '安全安保'
  },
  {
    id: 11809,
    value: '物流配送'
  },
  {
    id: 11810,
    value: '营销广告'
  },
  {
    id: 11811,
    value: '展会服务'
  },
  {
    id: 11812,
    value: '招商加盟'
  }
  ],
  id: 10018,
  value: '商务服务'
}]
